const CHECKBOX_TYPES = new Set(["checkboxes", "checkbox", "checkbox-group", "multiselect", "multi-select"]);

const INPUT_TYPES = new Set(["text", "email", "tel", "date", "number", "url", "password"]);

function parseOptions(raw) {
  if (Array.isArray(raw)) return raw.map(String).filter(Boolean);
  if (typeof raw === "string" && raw.trim()) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.map(String).filter(Boolean);
    } catch {
      return raw
        .split(/[\n,]/)
        .map((s) => s.trim())
        .filter(Boolean);
    }
  }
  return [];
}

function normalizeFieldType(type, options) {
  const raw = String(type || "text").trim().toLowerCase();
  if (CHECKBOX_TYPES.has(raw)) return "checkboxes";
  if (raw === "select" || raw === "dropdown") return "select";
  if (raw === "textarea" || raw === "longtext") return "textarea";
  if (INPUT_TYPES.has(raw)) return raw;
  // If options are provided but type was mistyped, treat as checkboxes when label suggests multi
  if (options.length > 0 && (raw === "text" || raw === "")) return "text";
  return raw;
}

export function normalizeFormField(field) {
  if (!field || typeof field !== "object") return null;

  const options = parseOptions(field.options);
  const type = normalizeFieldType(field.type, options);

  return {
    ...field,
    name: String(field.name || "").trim(),
    label: String(field.label || field.name || "").trim(),
    type,
    required: Boolean(field.required),
    options,
  };
}

/** Ensure `fields` is a parsed array with normalized types (for DynamicForm). */
export function normalizeFormFields(fields) {
  let list = fields;
  if (typeof list === "string") {
    try {
      list = JSON.parse(list);
    } catch {
      list = [];
    }
  }
  if (!Array.isArray(list)) return [];
  return list.map(normalizeFormField).filter((f) => f?.name);
}

export function normalizeForm(form) {
  if (!form || typeof form !== "object") return form;
  return {
    ...form,
    fields: normalizeFormFields(form.fields),
  };
}

export function isCheckboxField(field) {
  return field?.type === "checkboxes";
}
